module.exports = __webpack_public_path__ + "img/valve_electro.9252eb81.jpg";